module.exports = __webpack_public_path__ + "media/spa/check_icon-cbbd449d.svg";